import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { TASK_STATISTICS_FORM_NAME } from 'features/views/taskStatistics/form';

import Filter from './components/Form';
import ResultsTable from './components/ResultsTable';
import Toolbar from './components/Toolbar';

export const TaskStatistics = () => {
	return (
		<Panel
			screenId={PAGES.taskStatistics.id}
			screenName={PAGES.taskStatistics.name}
			floatingDialogs={<SubmitFormDialog pageName={TASK_STATISTICS_FORM_NAME} />}
		>
			<PaperWithToolbar
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.taskStatistics, initiallyOpen: true }}
			>
				<ResultsTable />
			</PaperWithToolbar>
		</Panel>
	);
};

export default TaskStatistics;
